// removed by extract-text-webpack-plugin
module.exports = {"root":"_1dQqP","descr":"_10aK7","features":"_3eERk","image":"_RA0PP","collapseBlock":"_2xs70"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/ProductFeatures/ProductFeatures.scss
// module id = 1358
// module chunks = 3